import React, {useEffect, useRef, useState} from "react";
import {Row, Col, Card, CardBody} from "reactstrap";
import LoadingScreen from "../../util/LoadingScreen";
import ApiService from "../../util/ApiService";
import Swal from "sweetalert2";
import UsersSearch from "../../dashboard/calender/UsersSearch";
import HospitalSearch from "../../hospital/HospitalSearch";
import Select from "react-select";
import Skeleton from "react-loading-skeleton";
import CustomPagination from "../../util/CustomPagination";
import PreferencesPresenceAttendanceControlModal from "./PreferencesPresenceAttendanceControlModal";


const PreferencesAttendanceControl = () => {
    const refDepartment = useRef(null);
    const buttonRefs = useRef({});
    const [dropdownOpenId, setDropdownOpenId] = useState(null);
    const selectInputRef = useRef();
    const hospitalSearchRef = useRef(null);
    const [loadingPage, setLoadingPage] = useState(false);
    const [showManagersListModal, setShowManagersListModal] = useState(false);
    const [specialtyOptions, setSpecialtyOptions] = useState([]);
    const [showRegisterPresenceModal, setShowRegisterPresenceModal] = useState(false);
    const [showRegisterPresenceLocalDepartmentModal, setShowRegisterPresenceLocalDepartmentModal] = useState(false);
    const [showDutyRetroactiveModal, setShowDutyRetroactiveModal] = useState(false);
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [selectedPreference, setSelectedPreference] = useState(null);

    const [departmentsFilter, setDepartmentsFilter] = useState([]);

    const [presenceConfig, setPresenceConfig] = useState([]);
    const [presenceConfigArray, setPresenceConfigArray] = useState([]);

    const [filters, setFilters] = useState({
        dateRange: "",
        status: null,
        hospital: "",
        department: ""
    });
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});

    const handlePageChange = (page) => fetch(page);

    const fetch = async (page = 1) => {
        try {
            setLoadingSearch(true);
            const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}presence/settings/all`,
                {
                pagination: pagination.pageSize,
                page,
                hospital_id: filters?.hospital,
                department_id: filters?.departament_id
            },
                true);

            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setPresenceConfigArray(data || []);
            setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingSearch(false);
        }
    };

    const onHospitalSelect = (hospital) => {
        setFilters((prev) => ({...prev, hospital: hospital?.value || null}));
    };

    const handleModalRegister = (data) => {
        setSelectedPreference(data); // define qual regra está sendo editada (ou null para nova)
        setShowRegisterPresenceModal(true);
    };





    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Tem certeza?",
            text: "Você deseja excluir essa regra?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Sim, excluir",
            cancelButtonText: "Não",
        });

        if (result.isConfirmed) {
            try {
                setLoadingPage(true);

                await ApiService.send("delete", `${process.env.REACT_APP_URL_API}presence/settings/delete`, { id });

                Swal.fire({
                    title: "Sucesso!",
                    text: "Deletado com sucesso.",
                    icon: "success",
                    confirmButtonText: "OK",
                });

              fetch(pagination.current);
            } catch (error) {
                ApiService.handleApiError(error);
            } finally {
                setLoadingPage(false);
            }
        }
    };




    const handleClearFilters = () => {
        if (refDepartment.current) refDepartment.current.clearValue();
        setFilters({dateRange: "", status: null, hospital: null, departament_id: null});
        if (hospitalSearchRef.current) hospitalSearchRef.current.clearHospital();

    };

    const handleRegisterManagersModalClose = (save = false) => {
        setShowRegisterPresenceModal(false);
        setShowDutyRetroactiveModal(false);
        if (save) fetch();
    };


    const fetchDepartmentsFilter = async () => {
        try {
            const response = await ApiService.send("post", `${process.env.REACT_APP_URL_API}departments/list-department`, {
                all: true,
                status: 'S'
            }, true);
            if (response.code === 200) {
                const {data} = ApiService.handleApiResponse(response);
                setDepartmentsFilter(Array.isArray(data) ? data : []);
            } else {
                Swal.fire("Erro", "Erro ao carregar os departamentos.", "error");
            }
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    const fetchSpecialties = async () => {
        try {
            const storedSpecialties = localStorage.getItem("specialties-select");

            if (storedSpecialties) {
                setSpecialtyOptions(JSON.parse(storedSpecialties));
            } else {
                const response = await ApiService.send('get', `${process.env.REACT_APP_URL_API}specialties/list`);

                const {data} = ApiService.handleApiResponse(response);

                const options = data.map(specialty => ({
                    value: specialty.id,
                    label: specialty.name,
                }));
                localStorage.setItem("specialties-select", JSON.stringify(options));
                setSpecialtyOptions(options);
            }
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };


    useEffect(() => {
        fetch();
        fetchDepartmentsFilter();
        fetchSpecialties();
    }, []);

    return (
        <Row>
            {loadingPage && <LoadingScreen/>}


            <div className="col-md-4">
                <HospitalSearch
                    buttonAdd={false}
                    ref={hospitalSearchRef}
                    onHospitalSelect={onHospitalSelect}
                    validateManager={true}
                    cache={false}
                />

            </div>
            <div className="col-md-4 form-group">
                <label>Departamentos</label>
                <Select
                    isClearable
                    ref={refDepartment}
                    options={departmentsFilter.map((dept) => ({value: dept.id, label: dept.name}))}
                    onChange={(dept) => setFilters((prev) => ({...prev, departament_id: dept?.value || ""}))}
                    classNamePrefix="select"
                    placeholder="Selecionar Departamento..."
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: base => ({...base, zIndex: 9999}),
                        menu: base => ({...base, zIndex: 9999})
                    }}
                />
            </div>

            <div className="row mt-4">
                <div className="col-md-12 d-flex justify-content-end">
                    <button className="btn mr-1 me-2" onClick={handleClearFilters}><i
                        className="fa fa-eraser"></i> Limpar Filtros
                    </button>
                    <button className="btn btn-info mr-1 me-2" onClick={() => handleModalRegister(null)}><i
                        className="fa fa-plus"></i> Cadastrar Regra
                    </button>
                    <button className="btn btn-success" onClick={() => fetch()} disabled={loadingSearch}>
                        <i className={`fa ${loadingSearch ? "spinner-border spinner-border-sm me-2" : "fa-search"}`}></i> {loadingSearch ? "Buscando..." : "Buscar"}
                    </button>
                </div>
            </div>

            <div className="list-container mt-4">
                {loadingSearch ? (
                    <Skeleton count={5} height={120}/>
                ) : presenceConfigArray.length > 0 ? (
                    presenceConfigArray.map((data) => (
                        <Col lg={12} key={data.id}>
                            <Card className="mb-1 p-2 shadow-sm card-hover">
                                <CardBody className="card-body d-flex justify-content-between align-items-center p-2">
                                    <div className="col-10 d-flex align-items-center">
                                        <div className="col-9 ms-2">
                                            <h6 className="doc-name">{data?.name || ("#" + data.id)}</h6>
                                            <p className="text-muted mb-1">
                                                <i className="fa fa-hospital-o text-info me-2"></i>
                                                <strong>Departamento:</strong>{" "}
                                                {
                                                    Array.isArray(data?.presence_settings_departments) && data.presence_settings_departments.length > 0
                                                        ? data.presence_settings_departments
                                                            .map(item => item?.department?.name)
                                                            .filter(Boolean)
                                                            .join(", ")
                                                        : "Não informado"
                                                }
                                            </p>

                                            <p className="text-muted mb-1">
                                                <i className="fa fa-dochub text-info me-2"></i>
                                                <strong>Local:</strong>{" "}
                                                {
                                                    Array.isArray(data?.presence_settings_hospitals) && data.presence_settings_hospitals.length > 0
                                                        ? data.presence_settings_hospitals
                                                            .map(item => item?.hospital?.name)
                                                            .filter(Boolean)
                                                            .join(", ")
                                                        : "Não informado"
                                                }
                                            </p>
                                            <p>
                                            {data.enabled === 1 ? (
                                                <span
                                                    className="badge bg-success d-inline-flex align-items-center">
                                                                                  <i className="fa fa-check me-2"></i> Situação Ativo
                                                                                </span>
                                            ) : (
                                                <span
                                                    className="badge bg-danger d-inline-flex align-items-center">
                                                                                      <i className="fa fa-times me-2"></i> Situação Inativo
                                                                                    </span>

                                            )}
                                        </p>

                                        </div>
                                    </div>

                                    <button className="btn btn-info  btn-sm me-1"
                                            onClick={() => {
                                                handleModalRegister(data);
                                                setDropdownOpenId(null);
                                            }}>
                                        <i className="fa fa-edit"></i> Editar
                                    </button>
                                    <button className="btn btn-danger btn-sm me-1"
                                            onClick={() => {
                                                handleDelete(data.id);
                                            }}>
                                        <i className="fa fa-trash" aria-hidden="true"></i> Excluir
                                    </button>

                                </CardBody>
                            </Card>
                        </Col>
                    ))
                ) : (
                    <div className="alert alert-primary" role="alert">Nenhum funcionário encontrado para cadastro de
                        regras</div>
                )}
            </div>

            <CustomPagination pagination={pagination} onChange={handlePageChange}/>

            <PreferencesPresenceAttendanceControlModal
                show={showRegisterPresenceModal}
                onHide={handleRegisterManagersModalClose}
                preferences={selectedPreference}
            />


        </Row>
    );
};

export default PreferencesAttendanceControl;
